export enum CommentSortUiEnum {
  STATE = 'STATE',
  UNREAD = 'UNREAD',
  CREATED_AT = 'CREATED_AT',
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  CREATED_AT_ASC = 'CREATED_AT_ASC',
}
